import { useState, useEffect } from "react";

export default function PaymentMonitor() {
    const [paymentData, setPaymentData] = useState(null);

    const loadFromStorage = () => {
// ✅ Read and parse the data safely from localStorage
        const paymentData = JSON.parse(localStorage.getItem("paymentData") || "{}");

// ✅ Destructure with safe default values
        const {
            total = 0,
            discount = 0,
            cashReceived = 0,
            customerExchange = 0,
        } = paymentData;

        return {
            total,
            discount,
            cashReceived,
            customerExchange,
        };
    };

    useEffect(() => {
        // Load on first mount
        const initial = loadFromStorage();
        if (initial) setPaymentData(initial);

        // Poll every 2 seconds until data appears
        const interval = setInterval(() => {
            const data = loadFromStorage();
            if (data) {
                setPaymentData(data);
                clearInterval(interval);
            }
        }, 2000);

        // Listen for storage changes (from other tabs or same app)
        const handleStorage = () => {
            const updated = loadFromStorage();
            setPaymentData(updated);
        };
        window.addEventListener("storage", handleStorage);

        return () => {
            clearInterval(interval);
            window.removeEventListener("storage", handleStorage);
        };
    }, []);

    // 🚫 No Data Yet
    if (!paymentData) {
        return (
            <div style={{ padding: "20px", width: "320px" }}>
                <input type="range" min="0" max="100" style={{ width: "100%" }} />
                <p>⏳ Waiting for payment data...</p>
            </div>
        );
    }

    // 🎉 Data Available
    // 🎉 Data Available
    if (paymentData.total == 0) {
        return (
            <div style={{
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "3rem",
                fontWeight: "bold",
                textAlign: "center"
            }}>
                Welcome to Zamzam
            </div>
        );
    }

    return (
        <div
            style={{
                height: "100vh",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    padding: "20px",
                    background: "#f8f9fa",
                    borderRadius: "12px",
                    textAlign: "center",
                    minWidth: "600px",
                    animation: "fadeScale 0.8s ease-in-out", // ✨ Animation applied
                }}
            >
                <h2>💰 Payment Status</h2>

                <h3
                    style={{
                        color: "red",
                        fontSize: "3rem",
                        animation: "fadeScale 0.8s ease-in-out",
                    }}
                >
                    Total: <strong style={{marginLeft:"20px"}}>¥{paymentData.total ?? 0}</strong>
                </h3>

                <h3
                    style={{
                        color: "red",
                        fontSize: "2.5rem",
                        animation: "fadeScale 0.8s ease-in-out",
                    }}
                >
                   Discount:  <strong style={{marginLeft:"20px"}}>¥{paymentData.discount ?? 0}</strong>
                </h3>

                <h3
                    style={{
                        color: "red",
                        fontSize: "2.5rem",
                        animation: "fadeScale 0.8s ease-in-out",
                    }}
                >
                    Received: <strong style={{marginLeft:"20px"}}>¥{paymentData.cashReceived !== ''? paymentData.cashReceived: 0}</strong>
                </h3>

                <h3
                    style={{
                        color: "red",
                        fontSize: "2.5rem",
                        animation: "fadeScale 0.8s ease-in-out",
                    }}
                >
                    Change: <strong style={{marginLeft:"20px"}}>¥ {paymentData.customerExchange !== ''? paymentData.customerExchange: 0}</strong>
                </h3>
            </div>

            {/* Add keyframes for animation */}
            <style>
                {`
        @keyframes fadeScale {
          0% { opacity: 0; transform: scale(0.8); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}
            </style>
        </div>
    );

}
